// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import translate from "@insite/client-framework/Translate";
import { FormField, FormState } from "@keller/XDL/Utilities/form";

export interface SpecialRequestItemsFormState extends FormState {
    fields: {
        priceRange: FormField<string>;
        qtyNeeded: FormField<string>;
        upcNumber: FormField<string>;
        manufacturerName: FormField<string>;
        mfgNumber: FormField<string>;
        manufacturerProductName: FormField<string>;
        description: FormField<string>;
        comments: FormField<string>;
    };
}

export const initialSpecialRequestItemsFormState: SpecialRequestItemsFormState = {
    isValid: false,
    isSubmitted: false,
    fields: {
        priceRange: {
            value: "",
            validators: ["required"],
            attrs: {
                id: "SpecialRequest_priceRange",
                name: "priceRange",
                label: translate("Price Range"),
                required: true,
            },
        },
        qtyNeeded: {
            value: "",
            validators: ["required"],
            attrs: {
                id: "SpecialRequest_qtyNeeded",
                name: "qtyNeeded",
                label: translate("Qty Needed"),
                placeholder: translate("Enter Qty Needed"),
                required: true,
                maxLength: 6,
            },
        },
        upcNumber: {
            value: "",
            attrs: {
                id: "SpecialRequest_upcNumber",
                name: "upcNumber",
                label: translate("UPC Number"),
                placeholder: translate("Enter UPC Number"),
                required: false,
                maxLength: 250,
            },
        },
        manufacturerName: {
            value: "",
            validators: ["required"],
            attrs: {
                id: "SpecialRequest_manufacturerName",
                name: "manufacturerName",
                label: translate("Manufacturer Name"),
                placeholder: translate("Enter Manufacturer Name"),
                required: true,
                maxLength: 250,
            },
        },
        mfgNumber: {
            value: "",
            validators: ["required"],
            attrs: {
                id: "SpecialRequest_mfgNumber",
                name: "mfgNumber",
                label: translate("MFG #"),
                placeholder: translate("Enter MFG #"),
                required: true,
                maxLength: 250,
            },
        },
        manufacturerProductName: {
            value: "",
            validators: ["required"],
            attrs: {
                id: "SpecialRequest_manufacturerProductName",
                name: "manufacturerProductName",
                label: translate("Manufacturer Product Name"),
                placeholder: translate("Enter Manufacturer Product Name"),
                required: true,
                maxLength: 250,
            },
        },
        description: {
            value: "",
            validators: ["required"],
            attrs: {
                id: "SpecialRequest_description",
                name: "description",
                label: translate("Description"),
                placeholder: translate("Enter Description"),
                required: true,
                maxLength: 500,
            },
        },
        comments: {
            value: "",
            attrs: {
                id: "SpecialRequest_comments",
                name: "comments",
                label: translate("Comments"),
                placeholder: translate("Enter Comments"),
                required: false,
                maxLength: 500,
            },
        },
    },
};
